import fetchArticleGrid from '~/assets/services/articleGrid/fetchArticleGrid';

export default fetchArticleGrid;
